const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_en_part3 = {
  originalEntries: "Original Entries",
  entry: "Entry",
  suggestedMergedEntry: "Suggested Merged Entry",
  aiExplanation: "AI Explanation:",
  applyMerge: "Apply Merge",
  applying: "Applying...",
  [duplicateTranslationKey("cancel")]: "Cancel",
  generateImprovementSuggestions: "Generate Improvement Suggestions",
  generateImprovementSuggestion: "Generate Improvement Suggestion",
  aiSuggestion: "AI Suggestion",
  applySuggestion: "Apply Suggestion",
  [duplicateTranslationKey("generating")]: "Generating...",
  hideAIRecommendations: "Hide AI-Generated Improvement Recommendations",
  showAIRecommendations: "Show AI-Generated Improvement Recommendations",
  affectedItems: "Affected items:",
  moreItems: "more items",
  current: "Current:",
  improved: "Improved:",
  suggestion: "Suggestion:",
  applyThisSuggestion: "Apply This Suggestion",
  identicalTitles: "Identical titles in the same knowledge base",
  similarTitlesContent: "Very similar titles and related content",
  similarContent: "Very similar content in the same knowledge base",
  applyingChanges: "Applying...",
  refineWithFeedback: "Refine with feedback",
  refinePlaceholder:
    "Write a short note to the AI (e.g., shorter, friendlier tone, include opening hours...)",
  refineSuggestion: "Refine Suggestion",
  suggestionRefined: "Suggestion refined!",
  failedToRefine: "Failed to refine suggestion",
  // Recommendation types (English)
  // Recommendation types (English)
  weakOrIncompleteContent: "Weak or Incomplete Content",
  weakContentDesc:
    "items appear incomplete or poorly phrased. Add missing details and improve clarity.",
  unclearOrVaguePrompts: "Unclear or Vague Prompts",
  unclearPromptsDesc:
    "prompts could be more specific. Consider adding more context and clear instructions.",
  missingClearCTA: "Missing Clear Call-to-Action",
  missingCTADesc: "prompts lack a clear call-to-action. Add specific next steps for users.",
  overlyGenericPrompts: "Overly Generic Prompts",
  genericPromptsDesc: "prompts are too generic. Make them more specific to your business.",
  overlyLongContent: "Overly Long Content",
  longContentDesc: "prompts are very long. Consider breaking them into smaller, focused pieces.",
  reviewOldContent: "Review Old Content",
  oldContentDesc:
    "items are older than 6 months and might need updating to reflect current best practices.",
  expiredContentCleanup: "Expired Content Cleanup",
  expiredContentDesc: "expired items that can be safely removed.",
  found: "Found",
  // Bug reporting translations
  // Bug reporting translations
  bugStatus: "Bug Status",
  reported: "reported",
  report: "Report",
  resolved: "resolved",
  [duplicateTranslationKey("suggestion")]: "suggestion",
  test_feedback: "test feedback",
  markResolved: "Mark as Resolved",
  removeStatus: "Remove Bug Status",
  reportBug: "Report Bug",
  reportInternalBug: "Report Internal Bug",
  reportSuggestion: "Report Suggestion",
  reportCriticalBug: "Report Critical Bug",
  reportAdminBug: "Report Admin Bug",
  critical_bug: "critical bug",
  admin_bug: "admin bug",
  showBugReport: "Report",
  hideBugReport: "Hide Bug Report",
  reportTypeOptions: "Choose report type or add comment",
  assign: "Assign",
  assignedTo: "Assigned to",
  assignedToMe: "Assigned to me",
  assignedToYou: "Assigned to you",
  unassign: "Unassign",
  unassigned: "Unassigned",
  unknownUser: "Unknown user",
  addCommentOrViewComments: "Add comment / View comments",
  commentsLabel: "Comments",
  noComments: "No comments yet",
  usernamePlaceholder: "Your name",
  addCommentPlaceholder: "Add a comment...",
  addComment: "Add Comment",
  adding: "Adding...",
  editComment: "Edit comment",
  deleteComment: "Delete comment",
  confirmDeleteComment: "Are you sure you want to delete this comment?",
  save: "Save",
  commentPlaceholder: "Comment",
  unreadComments: "Unread comments",
  title: "Title",
  text: "Text",
  selectIndexes: "Select indexes",
  enterTitle: "Enter title",
  enterText: "Enter text",
  selectExpirationDate: "Select expiration date",
  errorUploadingData: "Error uploading data",
  "Title is Required": "Title is Required",
  "Index is Required": "Index is Required",
  uploadDataTitle: "Upload Data",
  // Additional error and UI messages
  // Additional error and UI messages
  authTokenNotFound: "Authentication token not found.",
  errorFetchingUsers: "Error fetching users",
  errorFetchingUserIndexes: "Error fetching user's knowledge base indexes",
  noTextContentFound: "No text content found in PDF",
  errorExtractingPdfText: "Error extracting text from PDF. Please try again.",
  selectAccessibleUser: "Select Accessible User",
  selectAccessibleUserPlaceholder: "Select accessible user",
  selectUser: "Select User",
  selectUserToManage: "Select User to Manage",
  selectUserToManagePlaceholder: "Select user to manage",
  noMatchingResults: "No matching results found",
  noDataFoundForUser: "No data found for {username}",
  noDataFound: "No data found",
  pleaseSelectUserBase: "Please select a user",
  fromAccessibleUsers: "from your accessible users",
  toManageTheirData: "to manage their data",
  pleaseSelectOrganization: "Please select an organization.",
  pleaseSelectOrganizationToManage: "Please select an organization to manage their data",
  selectOrganization: "Select Organization",
  selectOrganizationPlaceholder: "Select organization",
  noDataFoundForOrganization: "No data found for {name}",
};
